import React from "react";

// region Imports - Atoms
import LoginBackground from "@atoms/LoginBackground";
// endregion Imports - Atoms
// region Imports - Molecules
import { SignUpForm } from "@molecules/index";
// endregion Imports - Molecules
// region Imports - Styles
import * as Styled from "./styles";
// endregion Imports - Styles

const SignUp: React.FC = () => (
  <Styled.Container>
    <LoginBackground />
    <Styled.FormContainer>
      <SignUpForm />
    </Styled.FormContainer>
  </Styled.Container>
);

export default SignUp;
